__turbopack_context__.v({
  "logo": "wczKAG_logo",
});
